<template>
  <layout-no-padding>
    <transition name="fadeToggle" mode="out-in" v-if="!!rctis">
      <v-flex>
        <v-card>
          <v-container fluid>
            <v-layout row wrap class="vertical-center-container">
              <multi-actions page="rctis" :selectedCount="selectedCount" v-if="!reportsPage"></multi-actions>
              <v-spacer></v-spacer>
              <v-flex xs12 sm2 md4 class="text-xs-right">
                <v-tooltip bottom v-if="selected.length > 0">
                  <v-btn flat color="grey" icon @click="selected = [];" slot="activator">
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  <span>Deselect All</span>
                </v-tooltip>
                <v-menu
                  bottom
                  left
                  transition="scale-transition"
                  max-height="600px"
                  origin="top right"
                  :close-on-content-click="false"
                  v-model="fieldChooserMenu"
                >
                  <v-btn flat icon color="grey" slot="activator">
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile v-for="header of possibleHeaders" :key="header.value">
                      <v-list-tile-action>
                        <v-checkbox
                          :color="$store.state.global.pages[$route.name].color"
                          v-model="defaultHeaders"
                          :label="header.text"
                          :value="header.value"
                        ></v-checkbox>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-flex>

              <!-- SELECT ALL TRIPS ALERT -->
              <v-alert
                v-if="selected.length >= 10"
                :value="true"
                color="grey lighten-3"
                icon="notification_important"
                style="width: 100%; border-radius: 4px;"
                class="grey--text text--darken-2 py-1"
              >
                <div class="flex-container-center">
                  <span>{{selected.length}} items are selected.</span>
                  <v-btn
                    v-if="selected.length == filteredRctis.length"
                    @click="selected = []"
                    flat
                    color="grey"
                  >Unselect all {{$vuetify.breakpoint.smAndUp ? `${selected.length} items` : ''}}</v-btn>
                  <v-btn
                    v-else
                    @click="selected = filteredRctis"
                    flat
                    :color="$store.state.global.pages.rcti.color"
                  >Select all {{$vuetify.breakpoint.smAndUp ? `${filteredRctis.length} items` : ''}}</v-btn>
                </div>
              </v-alert>
            </v-layout>
          </v-container>

          <div class="px-4" style="display: flex; align-items: center;">
            <div style="width: 15px; height: 15px; border-radius: 50px" class="indigo mr-3"></div>
            <span class="grey--text font-italic">Approved RCTIs will be automatically sent at 5PM</span>
          </div>
          <v-data-table
            :items="filteredRctis"
            :headers="headers"
            :rows-per-page-items="itemsPerPageOptions"
            v-model="selected"
            select-all
            :loading="loading"
            :search="!filterCol ? filterBy : ''"
            disable-initial-sort
          >
            <template slot="no-data">
              <div class="text-xs-center grey--text subheading">No RCTIs for the selected criteria.</div>
            </template>
            <template slot="items" slot-scope="props">
              <rcti-row
                :rcti="props.item"
                :value="props.selected"
                :headers="headers"
                @input="toggleSelected"
                :key="props.item.id"
              ></rcti-row>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </transition>
  </layout-no-padding>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import RctiService from "@/services/requests/rctiService";
import RctiRow from "@/components/rctis/rctiRow";
import MultiActions from "@/components/trips/actions/multiTripActions";
import RctiHeaders from "@/components/rctis/rctiHeaders";
import HeaderFilters from "@/services/mixins/headerFilters";
import { format } from "date-fns";

export default {
  mixins: [RctiHeaders, HeaderFilters],
  data() {
    return {
      color: "blue",
      searchTerm: "",
      fieldChooserMenu: false
    };
  },
  methods: {
    toggleSelected(val) {
      if (val.value) {
        this.selected.push(val.object);
      } else {
        var index = this.selected.indexOf(val.object);
        this.selected.splice(index, 1);
      }
    },
    getRctis() {
      if (!!this.$route.query.ids && this.showCreated) {
        var ids = JSON.parse(this.$route.query.ids);
        this.getRctisBy({ ids: ids });
      } else {
        this.showingCreated = false;
        this.getRctisByBillingPeriod();
      }
    },
    getRctisBy(payload) {
      this.loading = true;
      RctiService.getRctis(payload)
        .then(result => {
          if (!!payload.ids)
            result.data.result.forEach(rcti => {
              rcti.new = true;
            });
          this.rctis = result.data.result;
          this.loading = false;
        })
        .catch(err => {
          this.snackError();
          this.loading = false;
        });
    },
    getRctisByBillingPeriod() {
      // if (!this.billingPeriod) this.billingPeriod = format(new Date(), 'YYYY-MM')
      this.loading = true;
      RctiService.getRctisByBillingPeriod(this.billingPeriod)
        .then(result => {
          ////console.log(result.data);
          //this.rctis = this.getRctiTotals(result.data.result);
          this.rctis = result.data.result;
          ////console.log(this.rctis);
          this.loading = false;
        })
        .catch(err => {
          this.snackError();
          console.log(err);
          this.loading = false;
        });
    },
    getConfirmedRctis() {
      this.loading = true;
      RctiService.getConfirmedRctis()
        .then(result => {
          ////console.log(result.data);
          this.rctis = result.data.result;
          this.loading = false;
        })
        .catch(err => {
          this.snackError();
          console.log(err);
          this.loading = false;
        });
    }
  },
  computed: {
    rctis: Store.getSet({ store: "rctis", prop: "rctis" }),
    loading: Store.getSet({ store: "rctis", prop: "loading" }),
    filterBy: Store.getSet({ store: "rctis", prop: "filterBy" }),
    filterCol: Store.getSet({ store: "rctis", prop: "filterCol" }),
    dates: Store.getSet({ store: "rctis", prop: "dates" }),
    selected: Store.getSet({ store: "rctis", prop: "selected" }),
    billingPeriod: Store.getSet({ store: "shared", prop: "billingPeriod" }),
    projectId: Store.getSet({ store: "shared", prop: "projectId" }),
    showCreated: Store.getSet({ store: "shared", prop: "showCreated" }),
    selectedCount() {
      return this.selected.length;
    },
    //showClosed: Store.getSet({store: 'shared', prop: 'showClosed'}),
    filteredRctis() {
      if (!this.filterCol || !this.filterBy || this.reportsPage) {
        return this.rctis;
      }
      return this.rctis.filter(rcti => {
        if (this.getObjectPath(this.filterCol, rcti) != null) {
          return (
            this.getObjectPath(this.filterCol, rcti)
              .toString()
              .toLowerCase()
              .indexOf(this.filterBy.toString().toLowerCase()) > -1
          );
        }
      });
    },
    dateFilteredRctis() {
      //console.log('dateFilter triggered');
      if (!!this.dates.length) {
        ////console.log('dates has length')
        return this.filteredRctis.filter(rcti => {
          ////console.log(rcti.docket);
          return true;
          //return rcti.docket.date >= this.dates[0] && rcti.docket.date <= this.dates[1]
        });
      } else {
        return this.filteredRctis;
      }
    },
    reportsPage() {
      if (this.$route.name == "showReport") {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    if (!!this.$route.query.ids) {
      this.showCreated = true;
    } else {
      this.showCreated = false;
    }
    if (!this.reportsPage) this.getRctis();
  },
  beforeDestroy() {
    this.rctis = [];
    this.selected = [];
  },
  components: {
    RctiRow,
    MultiActions
  },
  props: {
    page: String
  },
  watch: {
    billingPeriod(val) {
      this.getRctis();
    },
    projectId(val) {
      this.getRctis();
    },
    showCreated(val) {
      this.getRctis();
    }
  }
};
</script>

<style>
</style>
